/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryManagerFormConfiguration
 */
export interface AncillaryManagerFormConfiguration {
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof AncillaryManagerFormConfiguration
     */
    readonly ancillaries?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof AncillaryManagerFormConfiguration
     */
    readonly ancillaryCategories?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof AncillaryManagerFormConfiguration
     */
    weights?: Array<Int32IdAndLabel> | null;
}

export function AncillaryManagerFormConfigurationFromJSON(json: any): AncillaryManagerFormConfiguration {
    return AncillaryManagerFormConfigurationFromJSONTyped(json, false);
}

export function AncillaryManagerFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryManagerFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ancillaries': !exists(json, 'ancillaries') ? undefined : (json['ancillaries'] === null ? null : (json['ancillaries'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'ancillaryCategories': !exists(json, 'ancillaryCategories') ? undefined : (json['ancillaryCategories'] === null ? null : (json['ancillaryCategories'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'weights': !exists(json, 'weights') ? undefined : (json['weights'] === null ? null : (json['weights'] as Array<any>).map(Int32IdAndLabelFromJSON)),
    };
}

export function AncillaryManagerFormConfigurationToJSON(value?: AncillaryManagerFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'weights': value.weights === undefined ? undefined : (value.weights === null ? null : (value.weights as Array<any>).map(Int32IdAndLabelToJSON)),
    };
}


